<template>
  <validation-observer ref="step1">
    <b-form
      ref="productForm"
      @submit.prevent="formSubmitted"
      @change="formChanged()"
    >
      <b-row>
        <b-col md="6">
          <b-form-group label="Product Name*" label-for="mc-Product-name">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Product Name"
            >
              <b-form-input
                id="mc-Product-name"
                placeholder="Product Name"
                v-model="details.name"
                required
              />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Product classification*"
            label-for="mc-Product-name"
          >
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Product classification"
            >
              <b-form-select
                v-model="details.type"
                :options="productTypes"
                placeholder="Product Classification"
              />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Enable Ecommerce" label-for="mc-Product-Ecomm">
            <b-form-checkbox
              checked="false"
              v-model="details.isEcomm"
              name="check-button"
              switch
              inline
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="Product Code" label-for="mc-Product-Code">
            <b-form-input
              id="mc-Product-Code"
              placeholder="Product Code"
              v-model="details.code"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Barcode" label-for="mc-Barcode">
            <b-form-input
              id="mc-Barcode"
              type="text"
              placeholder="Barcode"
              v-model="details.barcode"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-for="mc-stock-threshold" label="Unit Of Measure">
            <div class="form-label-group">
              <b-form-select
                v-model="details.uom"
                :options="itemUomList"
                value-field="id"
                text-field="name"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="mc-stock-threshold"
            label="Low Stock Threshold"
          >
            <div class="form-label-group">
              <validation-provider v-slot="{ errors }" name="Low Stock Threshold" rules="min_value:0">
              <b-form-input
                id="mc-stock"
                type="text"
                placeholder="Low Stock Threshold"
                v-model="details.lowStock"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-form-group>
        </b-col>
        <!-- <b-col md="6">
          <b-form-group label-for="batchqty" label="Batch Quantity">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Batch Quantity"
            >
              <b-form-input
                id="mc-Product-batchqty"
                placeholder="Batch Quantity"
                v-model="details.productionLimit"
              />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <b-col md="6">
          <b-form-group
            label-for="productionCapacity"
            label="Production Capacity"
          >
           
              <b-form-input
                id="mc-Product-productionCapacity"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                placeholder="Production Capacity"
                v-model="details.productionLimit"
              />
             
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Category" label-for="mc-Category">
            <b-form-select
              v-model="details.categoryId"
              :options="parentCategoryList"
              value-field="id"
              text-field="name"
              @change="fetchCategoryDetails"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            :disabled="details.categoryId != null"
            label="Sub Category"
            label-for="mc-subCategory"
          >
            <b-form-select
              v-model="details.productCategorySubId"
              :options="subCategoryList"
              value-field="id"
              text-field="name"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Preferred Supplier" label-for="mc-Supplier">
            <b-form-select
              v-model="details.supplierId"
              :options="supplierList"
              value-field="id"
              text-field="name"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mb-2">
          <label for="textarea-default">Product Description</label>
          <b-form-textarea
            id="textarea-default"
            placeholder="Product Description"
            rows="5"
            v-model="details.description"
          />
        </b-col>
        <b-col cols="12">
          <label for="textarea-default">Product Image</label>
          <b-form-file
            v-model="details.file"
            placeholder="Choose a product picture or drop it here..."
            drop-placeholder="Drop picture here..."
            @change="handleFileChange"
            ref="file-input"
            accept=".jpg, .jpeg, .png"
          />

          <div v-if="errorMessage.length > 0" class="error-message text-danger">{{ errorMessage }}</div>

          <b-card-text class="my-2">
            Selected Image:
            <div v-if="imageSrc">
              <div
                style="
                  position: relative;
                  display: inline-block;
                  max-width: 10%;
                  height: auto;
                "
              >
                <img
                  :src="imageSrc"
                  alt="Selected Image"
                  class="img-thumbnail bg-transparent border-0"
                />
                <div class="position-absolute close-btn btn-overlay">
                  <b-button variant="link" @click="clearImage" class="p-0">
                    <feather-icon icon="XIcon" size="24" color="red" />
                  </b-button>
                </div>
              </div>
            </div>
            <strong v-if="!imageSrc">{{
              details.file ? details.file.name : ""
            }}</strong>
          </b-card-text>
        </b-col>
      </b-row>
      <CustomFieldsDetails
        :AdditionalFields="details.additionalFields"
        :ModuleReference="'Product'"
        @onchange="additionalFieldChanges"
      ></CustomFieldsDetails>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormTextarea,
  BFormSelect,
  BFormFile,
  BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { fnSortingDropdown, customError, customSwal } from "@/libs/customFn";

extend("required", required);

export default {
  components: {
    BRow,
    BFormSelect,
    BCol,
    ToastificationContent,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BButton,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    CustomFieldsDetails,
    fnSortingDropdown,
  },
  directives: {
    Ripple,
  },
  methods: {
    async fetchCategoryDetails(id) {
      this.subCategoryList = await this.getItemSubCategoryListAction(this.details.categoryId);
      this.subCategoryList = fnSortingDropdown(
        this.subCategoryList,
        "asc",
        "name"
      );
    },
    async formValidation() {
      let stepValidation = await this.$refs.step1.validate();
      this.$refs.step1.validate().then((stepValidation) => {
        if (!stepValidation) {
          // Find the first invalid field
          const firstErrorField = this.$el.querySelector(".text-danger");
          if (firstErrorField) {
            // Scroll to the first invalid field
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
            // Set focus on the first invalid field
            firstErrorField.focus();
          }
        }
      });
      return stepValidation;
    },
    formSubmitted() {
      this.$router.push("/product/list/");
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Product Successfully Added",
          icon: "EditIcon",
          variant: "success",
        },
      });
      this.$bvModal.hide("modal-1");
    },
    clearImage() {
      this.details.file = null;
      this.imageSrc = null;
    },
    cancelUpload() {
      // Find the file input element and reset its value
      this.details.file = null;
      this.imageSrc = null;
      this.$refs["file-input"].reset();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      console.log("File:", file);
      if (file) {
        // Log file type for debugging
        console.log("File type:", file.type);
        console.log("File name:", file.name);

        // Validate file type
        const validTypes = ["image/jpeg", "image/png"];
        const validExtensions = ["jpg", "jpeg", "png"];

        // Extract the file extension
        const fileExtension = file.name.split(".").pop().toLowerCase();
        console.log("File extension:", fileExtension);

        if (
        !validTypes.includes(file.type) ||
          !validExtensions.includes(fileExtension)
        ) {
          this.errorMessage = "Only JPG, JPEG, and PNG files are allowed.";
          this.cancelUpload();
          return;
        } else {
          this.errorMessage = "";
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imageSrc = e.target.result;
          };
          reader.readAsDataURL(file);
        }
      }
    },
    ...mapActions("itemUomModule", ["getItemUOMListAction"]),
    ...mapActions("itemcategoryModule", ["getItemCategoryListAction", "getItemCategoryAction", "getItemSubCategoryListAction"]),
    ...mapActions("supplierModule", ["getSupplierListAction"]),
    additionalFieldChanges(customFields) {
      this.details.additionalFields = customFields;
    },
    formChanged() {
      this.$emit("onchange", this.details);
    },
  },
  data() {
    return {
      productTypes: [
        { value: 1, text: "Finished" },
        { value: 2, text: "Semi Finished" },
      ],
      details: {
        name: null,
        type: null,
        code: null,
        barcode: null,
        uom: null,
        lowStock: null,
        productionLimit: 0,
        productionCapacity: 0,
        categoryId: null,
        productCategorySubId: null,
        supplierId: null,
        description: null,
        letter: null,
        file: null,
        additionalFields: [
          {
            fieldName: null,
            fieldValue: null,
            fieldType: "text",
            isRequired: false,
            displayEcomm: false,
          },
        ],
      },
      imageSrc: null, // Add this line
      parentCategoryList: [],
      subCategoryList: [],
      supplierList: [],
      itemUomList: [],
      errorMessage: ""
    };
  },
  computed: {
    ...mapGetters("itemUomModule", {
      itemUoms: "itemuom",
      loading: "loading",
    }),
    ...mapGetters("itemcategoryModule", {
      itemCategories: "itemcategories",
      loading: "loading",
    }),
    ...mapGetters("supplierModule", {
      suppliers: "suppliers",
      loading: "loading",
    }),
  },
  async mounted() {
    await this.getItemUOMListAction();
    await this.getItemCategoryListAction();
    await this.getSupplierListAction();

    this.itemUomList = fnSortingDropdown(this.itemUoms, "asc", "name");
    this.parentCategoryList = fnSortingDropdown(
      this.itemCategories.filter((x) => !x.isSub),
      "asc",
      "name"
    );
    console.log("this.parentCategoryList",this.parentCategoryList)
    this.supplierList = fnSortingDropdown(this.suppliers, "asc", "name");
  },
};
</script>
<style lang="css">
.close-btn {
  top: 0;
  right: 0;
}
</style>
